import { useState } from 'react';
import { useRecoilValue } from 'recoil';

import { SandhillsSlickSlider } from '@Components/Shared/SandhillsSlickSlider';
import ListingQuoteCard from '@Components/Shared/ListingQuoteCard';
import atoms from '@Components/Utilities/SandhillsAtoms';
import TranslationText from '@Components/Utilities/TranslationText';

const QuoteCardCarousel = (props) => {
    const routes = useRecoilValue(atoms.routes);
    const emptyLegCards = props?.EmptyLegs || [];

    const sliderSettings = {
        dots: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        infinite: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            }
        ]
    };

    const ScrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'scrolltop'
        });
    };

    return (
        <>
            <div className="container">
                <div className="heading-flex">
                    <h2><TranslationText tKey='sandhills.tradesites.mvc.emptylegdeals' /></h2>
                    <a className="ts-rounded-button" href={routes.EmptyLegsDirectory}>
                        View All Available Empty Legs
                    </a>
                </div>
                <SandhillsSlickSlider
                    settings={sliderSettings}
                >
                    {emptyLegCards?.map((card, index) => (
                        <ListingQuoteCard {...card} key={index} />
                    ))}
                </SandhillsSlickSlider>
                <div className="empty-leg-alerts">
                    Not finding what you're looking for? <a className="alert-btn" href={routes.EmptyLegsAlerts}>Set Up Empty Leg Alerts</a>
                </div>
            </div>
            <div className='ready-section'>
                <div className="container">
                    <h2><TranslationText tKey='sandhills.tradesites.mvc.readytofly' /></h2>
                    <div className="btn-container">
                        <button className="ts-rounded-button ready-section-button" onClick={ScrollTop}>Request A Quote</button>
                        <a className="ts-rounded-button ready-section-button" href={routes.EmptyLegsDirectory}>Browse Empty Legs</a>
                    </div>
                </div>
            </div>
        </>
    );
};

export default QuoteCardCarousel;